<template>
    <div class="page bg-blue relative desktop-footer min-h-screen">
        <div class="bg-head-coin sm:block"></div>
        <div class="page-content sm:px-8 min-h-screen flex flex-col pb-5">
            <TopBar title="Home" :isShowOnlyLogo="true" :modalController="modalController"></TopBar>
            <MenuDesktop activeMenu="home"></MenuDesktop>
            <div class="sm:bg-white sm:px-5 sm:py-6 mt-4 rounded-25 flex flex-col flex-1 relative">
                <div class="bg-white rounded-25 mx-3 pt-10 pb-16 h-full flex-1">
                    <div class="px-10">
                        <div class="w-full text-center">
                            <img class="h-14 w-auto m-auto" src="../../assets/ic-register.png" />
                        </div>
                        <div class="text-center text-144394 text-24 pt-3">{{lbl.register.register}}</div>
                        <div class="text-center text-666666 text-20 pt-5">{{lbl.register.please_enter_id}}</div>
                        <div class="pt-6">
                            <InputRadioInline
                                class="mb-3 text-20"
                                v-model:inputValue="modelLogin.nationality"
                                :inputLbl="lbl.register.nationality"
                                :itemList="nationalityList"
                                :errorInfo="errorInfo[0]"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :isShowStar="true"
                            ></InputRadioInline>
                            <div v-if="isThaiNational">
                                <InputNationalId
                                    class="mb-3 text-20"
                                    ref="input-cardId"
                                    v-model:inputValue="modelLogin.idCard"
                                    :errorInfo="errorInfo[1]"
                                    :isFirstSave="isFirstSave"
                                    :isShowErrorLbl="isThaiNational"
                                    :isShowStar="isThaiNational"
                                    :inputLbl="lbl.register.id_card"
                                    :minLength="10"
                                    :maxLength="13"
                                ></InputNationalId>
                            </div>
                            <div v-else>
                                <InputText
                                    class="mb-3 text-20"
                                    ref="input-passport"
                                    v-model:inputValue="modelLogin.passport"
                                    :errorInfo="errorInfo[2]"
                                    :isFirstSave="isFirstSave"
                                    :isShowErrorLbl="!isThaiNational"
                                    :isShowStar="!isThaiNational"
                                    :inputLbl="lbl.register.passport">
                                </InputText>
                            </div>
                            <InputContactNumber
                                class="mb-3 text-20"
                                v-model:inputValue="modelLogin.mobile"
                                :errorInfo="errorInfo[3]"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :isShowStar="true"
                                :inputLbl="lbl.register.mobile"
                                :minLength="10"
                                :maxLength="12"
                                delimeter="-"
                            ></InputContactNumber>
                        </div>
                    </div>
                    <div class="w-250px text-20 mx-auto">
                        <BlueBtn @onClick="clickVerify()">{{lbl.register.confirm}}</BlueBtn>
                    </div>
                </div>
                <div class="absolute bottom-10 s:bottom-7 left-0 right-0 sm:hidden">
                    <div class="text-center">
                        <img class="w-44 m-auto pt-3" src="@/assets/poer-tip.png" />
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
    </div>
</template>
<script>
import { FormHelper } from "@/helper/FormHelper.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import BzbsRegister from "../../service/BzbsRegister";
import { RegisterModel } from '@/core/Account/model/RegisterModel'
//component
import InputNationalId from "@/components/Input/label/InputNationalId.vue";
import InputContactNumber from "@/components/Input/label/InputContactNumber.vue"
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import BlueBtn from "@/components/Button/BlueBtn.vue";
import InputRadioInline from "@/components/Input/label/InputRadioInline.vue";
import InputText from '@/components/Input/label/InputText.vue'
//mixin
// import ModalMixin from "@/mixin/ModalMixin.js";
export default {
    name: "Default",
    mixins: [LocaleMixin],
    components: {
        TopBar,
        MenuDesktop,
        InputNationalId,
        InputContactNumber,
        BottomBar,
        BlueBtn,
        InputRadioInline,
        InputText
    },
    props: {
        modalController: Object,
    },
    data: function() {
        return {
            isFirstSave: true,
            errorInfo: [],
            nationalityList: new RegisterModel().setNationalityList(),
            modelLogin: {
                nationality: "thai",
                idCard: "",
                passport: "",
                mobile: ""
            },
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(4);
    },
    computed: {
        isThaiNational: function(){
            if(this.modelLogin.nationality == 'thai'){
                return true
            }
            return false
        }
    },
    methods: {
        clickVerify:async function () {
            this.isFirstSave = false;
            this.lbl.register.id_card.required = '';
            this.lbl.register.id_card.too_short = '';
            this.lbl.register.passport.required = '';
            this.lbl.register.passport.too_short = '';
            if(this.modelLogin.nationality === 'thai'){ //ไทย
                this.lbl.register.id_card.required = 'กรุณากรอกรหัสบัตรประชาชน 13 หลัก';
                this.lbl.register.id_card.too_short = 'กรุณากรอกรหัสบัตรประชาชน 13 หลัก';
                this.$refs['input-cardId'].validateInput();
            }else{
                this.lbl.register.passport.required = 'กรุณากรอกเลขพาสปอร์ต 7 หลัก';
                this.lbl.register.passport.too_short = 'กรุณากรอกเลขพาสปอร์ต 7 หลัก';
                this.$refs['input-passport'].validateInput();
            }
            const isValid = FormHelper.validate(this.errorInfo);
            console.log(isValid);
            if (isValid) {

                await this.callApiVerifyMember();

                this.$emit('submitVerify', this.modelLogin);
            }
            // this.otpModal.show();
        },
        callApiVerifyMember: function () {

            this.modalController.loadingModal.show();
            return new Promise((resolve) => {
                BzbsRegister.verifyMember(this.modelLogin.mobile, this.modelLogin.idCard)
                    .subscribe({
                        next: (res) => {
                            console.log(res);
                            // if (res.data.length > 0) {
                            //     //รอทำ ตอนที่ user มีข้อมูลเอา data ที่ได้มาโยนไปที่ register
                            //     //this.$router.push('register');
                            //     //this.otpModal.show();
                            // }

                            this.modalController.loadingModal.hide();
                            resolve(res);
                        },
                        error: (err) => {
                            console.log(err);
                            this.modalController.loadingModal.hide();
                            resolve(null);
                        }
                });
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.logo-powerby {
    width: 166px;
}
</style>
